import { InjectionToken } from "@angular/core";
import type { ISideDialog } from "../types/side-dialog.interface";

export const SIDE_DIALOG_TOKEN = new InjectionToken<ISideDialog>('side-dialog.component')
